import { useEffect } from 'react';
import { ChatConfig } from '../types';
import { getBrandingColor, getBrandingFont, loadGoogleFonts } from '../utils/brandingUtils';

/**
 * Applies branding colors, fonts, and title from configuration.
 * Sets CSS variables and document title based on merchant branding.
 * @param config The chat configuration containing branding details.
 */
export function useBranding(config: ChatConfig | null) {
  useEffect(() => {
    if (!config) return;
    
    const primaryFont = getBrandingFont(config, 'primary');
    const secondaryFont = getBrandingFont(config, 'secondary');
    
    // Load Google Fonts
    loadGoogleFonts(primaryFont, secondaryFont);
    
    // Apply branding colors using CSS variables
    document.documentElement.style.setProperty('--color-primary', getBrandingColor(config, 'primary'));
    document.documentElement.style.setProperty('--color-secondary', getBrandingColor(config, 'secondary'));
    document.documentElement.style.setProperty('--color-background', getBrandingColor(config, 'background'));
    document.documentElement.style.setProperty('--color-text', getBrandingColor(config, 'text'));
    
    // Apply fonts using CSS variables
    document.documentElement.style.setProperty('--font-primary', primaryFont);
    document.documentElement.style.setProperty('--font-secondary', secondaryFont);
    
    // Apply title from config
    document.title = config?.branding?.chatTitle || 'MattressAI Chat';
  }, [config]);
} 